import { createContext, useContext } from 'react';

/** A Worksheet a rule can compare with: its id, name and Result columns. */
export interface WorkbookSheetChoice {
  id: string;
  name: string;
  columns: readonly string[];
}

export const WorkbookSheetChoicesContext = createContext<
  readonly WorkbookSheetChoice[]
>([]);

/** Every Worksheet but `sheetId`, to compare it with. */
export function useOtherSheets(sheetId: string): WorkbookSheetChoice[] {
  return useContext(WorkbookSheetChoicesContext).filter(
    (choice) => choice.id !== sheetId,
  );
}
